import React, { useState, useEffect } from 'react';

export default function EditObjectModal({ object, categories: initialCategories }) {
    const [isOpen, setIsOpen] = useState(false);
    const [formData, setFormData] = useState({
        title: object.title || '',
        category: object.category || '',
        location: object.location || '',
        dateFound: object.dateFound || '', // Utiliser directement le format Twig Y-m-d\TH:i
        description: object.description || '',
    });
    const [imageFile, setImageFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const categories = [
        { id: 'Valeurs', label: 'Portefeuille', icon: 'wallet' },
        { id: 'Clés', label: 'Clés', icon: 'key' },
        { id: 'Electronique', label: 'Électronique', icon: 'smartphone' },
        { id: 'Documents', label: 'Documents', icon: 'description' },
        { id: 'Vêtements', label: 'Vêtements', icon: 'checkroom' },
        { id: 'Autre', label: 'Autre', icon: 'category' }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        console.log('Submission data:', formData);

        const data = new FormData();
        Object.keys(formData).forEach(key => data.append(key, formData[key]));
        if (imageFile) {
            console.log('Adding image file:', imageFile.name);
            data.append('imageFile', imageFile);
        }

        try {
            const response = await fetch(`/api/objects/${object.id}`, {
                method: 'POST',
                body: data,
            });

            const result = await response.json();
            console.log('API Result:', result);

            if (result.success) {
                window.location.reload();
            } else {
                setError(result.error || 'Une erreur est survenue lors de la modification.');
            }
        } catch (err) {
            console.error('Fetch error:', err);
            setError('Erreur de connexion au serveur');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <button
                onClick={() => setIsOpen(true)}
                className="p-2 hover:bg-slate-200 dark:hover:bg-slate-700 rounded-lg text-slate-500 transition-colors"
                title="Modifier"
            >
                <span className="material-symbols-outlined text-sm">edit</span>
            </button>

            {isOpen && (
                <div className="fixed inset-0 z-[110] overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        {/* Overlay */}
                        <div
                            onClick={() => !loading && setIsOpen(false)}
                            className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"
                            aria-hidden="true"
                        ></div>

                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                        <div className="inline-block align-bottom bg-white dark:bg-slate-800 rounded-3xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full border border-slate-100 dark:border-slate-700">
                            <form onSubmit={handleSubmit}>
                                {/* Modal Header */}
                                <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-900/50">
                                    <h3 className="text-lg font-black text-slate-900 dark:text-white flex items-center gap-2">
                                        <span className="material-symbols-outlined text-primary">edit</span>
                                        Modifier l'objet
                                    </h3>
                                    <button
                                        type="button"
                                        onClick={() => setIsOpen(false)}
                                        className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors"
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>
                                </div>

                                {/* Modal Content */}
                                <div className="px-8 py-6 max-h-[70vh] overflow-y-auto">
                                    {error && (
                                        <div className="mb-4 p-4 bg-red-50 text-red-700 rounded-xl text-sm font-bold flex items-center gap-2">
                                            <span className="material-symbols-outlined text-sm">error</span> {error}
                                        </div>
                                    )}

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="flex flex-col gap-2">
                                            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Titre</label>
                                            <input
                                                type="text"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                required
                                                className="w-full h-12 px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-white focus:ring-primary focus:border-primary outline-none"
                                            />
                                        </div>

                                        <div className="flex flex-col gap-2">
                                            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Catégorie</label>
                                            <select
                                                name="category"
                                                value={formData.category}
                                                onChange={handleChange}
                                                required
                                                className="w-full h-12 px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-white focus:ring-primary focus:border-primary outline-none"
                                            >
                                                {categories.map(cat => (
                                                    <option key={cat.id} value={cat.id}>{cat.label}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="flex flex-col gap-2">
                                            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Lieu</label>
                                            <input
                                                type="text"
                                                name="location"
                                                value={formData.location}
                                                onChange={handleChange}
                                                required
                                                className="w-full h-12 px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-white focus:ring-primary focus:border-primary outline-none"
                                            />
                                        </div>

                                        <div className="flex flex-col gap-2">
                                            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Date</label>
                                            <input
                                                type="datetime-local"
                                                name="dateFound"
                                                value={formData.dateFound}
                                                onChange={handleChange}
                                                required
                                                className="w-full h-12 px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-white focus:ring-primary focus:border-primary outline-none"
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-6 flex flex-col gap-2">
                                        <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Description</label>
                                        <textarea
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            rows="4"
                                            className="w-full p-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-white focus:ring-primary focus:border-primary outline-none"
                                        ></textarea>
                                    </div>

                                    <div className="mt-6">
                                        <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1">Changer la photo (optionnel)</label>
                                        <div className="mt-2 relative w-full h-32 border-2 border-dashed border-slate-200 dark:border-slate-700 rounded-2xl flex flex-col items-center justify-center gap-2 bg-slate-50 dark:bg-slate-900/50 hover:bg-slate-100 transition-colors">
                                            <input
                                                type="file"
                                                onChange={(e) => setImageFile(e.target.files[0])}
                                                className="absolute inset-0 opacity-0 cursor-pointer"
                                            />
                                            <span className="material-symbols-outlined text-2xl text-slate-400">cloud_upload</span>
                                            <p className="text-xs font-bold text-slate-500">
                                                {imageFile ? imageFile.name : "Cliquez pour modifier la photo"}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Modal Footer */}
                                <div className="px-8 py-6 bg-slate-50 dark:bg-slate-900/50 border-t border-slate-100 dark:border-slate-700 flex justify-end gap-3">
                                    <button
                                        type="button"
                                        onClick={() => setIsOpen(false)}
                                        disabled={loading}
                                        className="px-6 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all hover:scale-105"
                                    >
                                        Annuler
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className={`px-8 py-2.5 rounded-xl bg-primary text-white text-sm font-bold shadow-lg shadow-primary/20 hover:scale-105 active:scale-95 transition-all flex items-center gap-2 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    >
                                        {loading && <span className="animate-spin text-sm">⏳</span>}
                                        Enregistrer les modifications
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
